// ----------------------------------------
// THIRD-PARTY PLUGINS
// ----------------------------------------
//
// All third-party plugins should be renamed with an '_' to prevent separate file being generated.
//
// The below is a list of commonly used plugins used for many projects. However, you should only
// include the libraries you need for your site. By default, most libraries are excluded.
// To add a third-party library to the project, add a '@' symbol to the 'codekit-prepend' line.
//

// General
// @codekit-prepend "vendor/_micromodal.js"             // For the mailchimp popup modal
// @codekit-prepend "vendor/_lazysizes.min.js"          // Lazy-loading images
// @codekit-prepend "vendor/_ls.unveilhooks.min.js"     // BG support for lazy-loading images
// @codekit-prepend "vendor/_ls.progressive.js"         // Parent-class toggle support for lazy-loading
// @codekit-prepend "vendor/_flickity.pkgd.min.js"      // Flickity carousel library.
// @codekit-prepend "vendor/_masonry.min.js"            // Masonry plugin for gallery.
// @codekit-prepend "vendor/_jquery.chocolat.min.js"    // Chocolat plugin for lightboxes.

const hidePromise = function(){
    const d = new Date();
    d.setTime(d.getTime() + (2*365*(24*60*60*1000)));
    document.cookie = "hidepromise=yes;expires=" + d.toUTCString() + ";path=/";
    document.getElementById('travel-promise').style.display = 'none';
}

$(document).ready(function(){

    // Fixes initial transitions firing on page load
    $('body').removeClass('preload');


    // ----------------------------------------
    // THIRD-PARTY PLUGIN CONFIG
    // ----------------------------------------

    // Allow throttling of function calls.
    const throttle = (func, limit) => {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit)
            }
        }
    };

    // Allow debouncing of function calls.
    const debounce = (func, wait, immediate) => {
        let timeout;
        return function() {
            const args = arguments;
            const context = this;
            const later = () => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };


    // ----------------------------------------
    // GLOBAL SCRIPTS (header/footer, etc)
    // ----------------------------------------

    // Init modals
    try {
        MicroModal.init();
    } catch (e) {}


    // In order to stop elements that use VH units from changing on
    // iOS, their heights are fixed here.
    const vhFix = () => {
        $('.vh-fix').each(function () {
            // Reset the height to auto.
            $(this).css({ height: '' });

            const viewportHeight = $(this).outerHeight();
            $(this).css({ height: viewportHeight });
        });
    };

    vhFix();

    let windowWidth = $(window).width();
    $(window).resize(debounce(function () {
        // Prevent the function from being called if the window width did not change.
        const newWindowWidth = $(window).width();

        if (newWindowWidth !== windowWidth) {
            windowWidth = newWindowWidth;
            vhFix();
        }
    }, 200));


    //
    // Mobile navigation
    //

    let menuOpen = false;
    const $mobileNav = $('#mobile-nav');
    const $header = $('.section-header');
    $('#menu').click(function (event) {
        event.preventDefault();

        if ($header.hasClass('opened')) {
            // Close the menu.
            menuOpen = false;
            $header.removeClass('opened');

            $mobileNav.fadeOut(200, () => {
                $mobileNav.find('.mobile-nav_item').removeClass('opened');
            });
        } else {
            // Open the menu.
            menuOpen = true;
            $header.addClass('opened');

            $mobileNav.css('padding-top', $header.outerHeight());
            $mobileNav.fadeIn(200);
            $mobileNav.find('.mobile-nav_item').each((index, elem) => {
                setTimeout(function () {
                    $(elem).addClass('opened');
                }, 70 * index);
            });

            $('html, body').animate({
                scrollTop: 0,
            }, 200);
        }

        return false;
    });

    $header.bind('touchmove', function (event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    });


    //
    // Header dropdowns
    //

    $('.section-header_item-submenu > a').click(function (event) {
        event.preventDefault();

        // Collapse all other menus.
        $(this).parent().siblings().each((index, elem) => {
            if (elem !== this) {
                $(elem).removeClass('opened');
            }
        });

        // Toggle this specific menu.
        $(this).parent().toggleClass('opened');

        return false;
    });


    //
    // Mute button
    //

    const $video = $('#hero-video');
    $('#hero-unmute').click(function () {
        const unmuted = $(this).hasClass('unmuted');

        $video.get(0).muted = unmuted;
        $(this).toggleClass('unmuted');
    });


    //
    // Animate the clouds
    //

    const $cloudSections = $('.section-clouds');
    $(window).scroll(throttle(animateClouds, 10));

    function animateClouds() {
        const scrollTop = $(window).scrollTop();

        $cloudSections.each(function () {
            const elemHeight = $(this).outerHeight();
            const offsetTop = $(this).offset().top - elemHeight;

            if (scrollTop >= offsetTop) {
                const percentage = ((scrollTop - offsetTop) / elemHeight) * 100;
                $(this).find('.section-padded-body_cloud').each(function () {
                    const direction = $(this).data('cloud');
                    const offset = -40 + (percentage * 0.15);

                    $(this).css(direction, `${offset}vw`);
                });
            }
        });
    }

    animateClouds();


    //
    // The Story page carousel
    //

    const $storyCarousel = $('.story-carousel').flickity({
        draggable: false,
        pageDots: false,
        prevNextButtons: false,

        // The default threshold of 3 seems way too low.
        dragThreshold: 10,

        on: {
            change: (index) => {
                $storyHeaderItems.removeClass('active');
                $storyHeaderItems.filter(`[data-index="${index}"]`).addClass('active');
            }
        }
    });

    $(window).on('load', function(){
        $storyCarousel.flickity('resize');
    });

    $('.story-carousel_prev').click(function (event) {
        event.preventDefault();

        $storyCarousel.flickity('previous');

        return false;
    });

    $('.story-carousel_next').click(function (event) {
        event.preventDefault();

        $storyCarousel.flickity('next');

        return false;
    });

    const $storyHeaderItems = $('.section-story_header_item').click(function (event) {
        event.preventDefault();

        const { index } = this.dataset;
        $storyCarousel.flickity('select', parseInt(index));

        return false;
    });



    //
    // Init the masonry gallery.
    //

    $('.section-gallery .grid').masonry({
        // set itemSelector so .grid-sizer is not used in layout
        itemSelector: '.grid-item',
        // use element for option
        columnWidth: '.grid-sizer',
        percentPosition: true,
        horizontalOrder: true
    });

    $('.chocolat-parent').Chocolat();



    //
    // Init the matrix gallery.
    //

    $('.block-gallery .carousel').flickity({
        // Fix for both performance and a weird height issue.
        lazyLoad: 2
    });



    //
    // Show the share buttons on articles.
    //

    $('#show-share-buttons').click(function (event) {
        event.preventDefault();

        $(this).hide();
        $(this).siblings('.social-share').show();

        return false;
    });



    //
    // Accordion block
    //

    $('.block-accordion_title').click(function () {
        if (!$(this).closest('.block-accordion_item').hasClass('active')) {
            $(this).closest('.block-accordion').find('.active').each(function () {
                $(this).removeClass('active');
                $(this).find('.block-accordion_content').slideUp(200);
            });
        }

        $(this).closest('.block-accordion_item').addClass('active');
        $(this).siblings('.block-accordion_content').slideToggle(200);
    });



    //
    // Mailchimp modal
    //

    if (window.localStorage && !localStorage.modalShown) {
        const modalInterval = setInterval(() => {
            if (!localStorage.dateVisited) {
                localStorage.setItem('dateVisited', (new Date()).toISOString());
            }

            const dateVisited = new Date(localStorage.getItem('dateVisited'));
            const dateDifference = ((new Date()) - dateVisited) / 600;

            const bodyHeight = $('html').outerHeight() - $(window).height();
            const scrollTop = $(window).scrollTop();
            const scrollPerc = scrollTop / bodyHeight;

            // If the user has been on the site for more than 3 minutes, show the modal.
            if (dateDifference >= 180 && scrollPerc >= 0.8) {
                MicroModal.show('subscribe');
                localStorage.setItem('modalShown', 'true');

                clearInterval(modalInterval);
            }
        }, 1000);
    }

    $('[data-micromodal-close]').click(function (event) {
        event.preventDefault();

        MicroModal.close();

        return false;
    });
});
